export const ALLOWED_BRAND_FONT_EXTENSIONS = [
  "ttf",
  "otf",
  "woff",
  "woff2",
] as const;

export interface CompanyFontUploadResult {
  fontUrl: string;
  fontFamily: string;
  fontFileName: string;
}

export interface PrintCardOrderApproverOption {
  email: string;
  role: string;
  givenName: string | null;
  familyName: string | null;
  fullName: string | null;
}
